import { styled, Box } from '@mui/material';

export const AnalyticsCreditsContainer = styled(Box)`
  height: 75vh;
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
`;
